export default __webpack_public_path__ + "static/char-s-03-kr-238f5e20c3bda55611774e1aed8672c2.webp";